import th from './translations/th';
export default {
  th
};